import { render } from "./ModalNewMenuItem.component.vue?vue&type=template&id=2fb4393d&scoped=true&ts=true"
import script from "./ModalNewMenuItem.component.vue?vue&type=script&lang=ts"
export * from "./ModalNewMenuItem.component.vue?vue&type=script&lang=ts"

import "./ModalNewMenuItem.component.vue?vue&type=style&index=0&id=2fb4393d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb4393d"]])

export default __exports__